<template>
  <div style="max-height: 50vh; overflow-y: auto;">
    <template v-if="notifications && notifications.length > 0">
      <span
        v-if="isClickAllViewed"
        class="ml-1"
        style="cursor: pointer;"
        @click="updateNotifications"
      >
        <br />
        <a-icon type="check-square" /> Marks all read / Đánh dấu đã đọc tất cả
        <hr class="mt-1" />
      </span>

      <a v-for="n in notifications" :key="n.id" @click="updateNotification(n)">
        <a-row
          class="mb-3 noti-item"
          :style="{
            color: n.isViewed ? '#ccc' : '',
          }"
        >
          <a-col :span="17">
            [ {{ changeNameServices(n.service) }} ]
            <strong> {{ n.title }} </strong>
            <div>
              {{ n.body }}
            </div>
          </a-col>
          <a-col :span="7">
            <a-icon type="user" />
            <strong> {{ n.author.fullname || n.author.username }} </strong
            ><br />
            <small> {{ $d(new Date(n.createdAt), "short") }} </small>
          </a-col>
        </a-row>
      </a>
    </template>
    <template v-else>
      <!-- <a-empty size="small">
        <span slot="description"> Không có thông báo mới nào! </span>
      </a-empty> -->
      <a-list item-layout="vertical" :data-source="[]" size="small"> </a-list>
    </template>
    <!-- <div v-for="n in notifications" :key="n.id">
      [ {{ changeNameServices(n.service) }} ]
      <strong>{{ n.author.fullname || n.author.username }}</strong> đã cập nhập
      <strong>{{ n.title }}</strong>
      <div>{{ n.body }}</div>
    </div> -->

    <!-- <a-list item-layout="vertical" :data-source="notifications" size="small">
      <a-list-item slot="renderItem" slot-scope="item">
        <a slot="actions">edit</a>
        <a slot="actions">more</a>
        <a-list-item-meta :description="item.body">
          <span slot="title">
            [ {{ changeNameServices(item.service) }} ]
            <strong>{{ item.title }}</strong></span
          >
        </a-list-item-meta>
        <div>content</div>
      </a-list-item>
    </a-list> -->
  </div>
</template>
<script>
import Query from "./query";
export default {
  props: {
    notifications: {
      type: Array,
      required: true,
    },
    deleteNotifications: {
      type: Function,
      default: () => {},
    },
    isClickAllViewed: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    changeNameServices(name) {
      if (name === "approval") {
        return " Procedure ";
      } else {
        return name;
      }
    },
    updateNotification(item) {
      const [, approvalId] = item.link.split("/approval/view/");
      const routerTaskId = this.$route.params.idTask;

      if (item && approvalId && item.service === "approval") {
        const variables = {
          id: item.id,
          isClicked: true,
          isViewed: true,
        };

        if (!item.isClicked) {
          this.$apollo
            .mutate({
              mutation: Query.updateNotification,
              variables,
            })
            .then(({ data }) => {
              if (data.updateNotification.id) {
                this.$router.push("/approval/view/" + approvalId);
                this.deleteNotifications([item]);
              }
            })
            .catch((error) => console.log(error));
        } else if (approvalId) {
          this.$router.push("/approval/view/" + approvalId);
          this.deleteNotifications([item]);
        }
      } else if (item.itemId) {
        const [projectId, taskId] = item.itemId.split(":");

        const variables = {
          id: item.id,
          isClicked: true,
          isViewed: true,
        };

        this.$apollo
          .mutate({
            mutation: Query.updateNotification,
            variables,
          })
          .then(({ data }) => {
            if (data.updateNotification.id) {
              if (routerTaskId !== taskId) {
                this.$router.push("/project/" + projectId + "/" + taskId);
              }
              // this.deleteNotifications([item]);
            }
          })
          .catch((error) => console.log(error));

        // this.deleteNotifications([item]);
      } else {
        window.location.href = item.link;
      }
    },
    updateNotifications() {
      const items = this.notifications.filter((e) => !e.isViewed);
      if (items && items.length > 0) {
        const variables = {
          ids: items.map((e) => e.id),
          isViewed: true,
        };

        this.$apollo
          .mutate({
            mutation: Query.updateNotifications,
            variables,
          })
          .then(({ data }) => {
            console.log("Đã xóa thành công!");
            this.deleteNotifications(items);
          })
          .catch((error) => console.log(error));
      }
    },
  },
};
</script>
<style scoped>
.noti-item {
  cursor: pointer;
  padding: 5px;
}
.noti-item:hover {
  background-color: #ececec;
}
</style>
